import React from "react";

const NotificationIcon = ({
  fill = "#387CFF",
  stroke = "#387CFF",
  ...props
}) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props} // Spread additional props (e.g., className, style)
  >
    <path
      d="M7.86667 15.2965C7.97826 15.5095 8.1423 15.6872 8.34166 15.8109C8.54102 15.9347 8.76839 16 9 16C9.23161 16 9.45898 15.9347 9.65834 15.8109C9.8577 15.6872 10.0217 15.5095 10.1333 15.2965M5 6.19888C5 5.08527 5.42143 4.01727 6.17157 3.22982C6.92172 2.44238 7.93913 2 9 2C10.0609 2 11.0783 2.44238 11.8284 3.22982C12.5786 4.01727 13 5.08527 13 6.19888C13 11.0976 15 12.4972 15 12.4972H3C3 12.4972 5 11.0976 5 6.19888Z"
      stroke={fill}
      strokeWidth="1.13"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default NotificationIcon;
